import React from 'react';
import VideoPlaylistLabels from './properties/videoPlaylistLabels';

interface VideoControlsProps {
  // videoId: string
  position: number;
  duration: string;
  // title: string,
  onPlay: (position: number) => void;
  labels: VideoPlaylistLabels;
}

const VideoControls = (props: VideoControlsProps): any => {
  const { onPlay, position, duration, labels } = props;
  const playClickHandler = (event: any) => {
    if (['Enter', ' '].indexOf(event.key) < 0) {
      return;
    }
    event.preventDefault();
    if (onPlay) {
      onPlay(position);
    }
  };
  return (
    <div className="video-playlist__controls">
      <span onClick={playClickHandler} className="play-link" onKeyDown={playClickHandler} role="button" tabIndex={-1}>
        <div className="btn-play">
          <span className="ic-videoRound" aria-hidden="true" />
        </div>
        <p className="play-text">{labels.play}</p>
      </span>
      <p className="video-playlist__duration">
        {labels.duration} <span className="duration">{duration}</span> {labels.minutes}
      </p>
    </div>
  );
};

export default VideoControls;
